import { render, staticRenderFns } from "./TravellerMsg.vue?vue&type=template&id=b7ae6f8a"
import script from "./TravellerMsg.vue?vue&type=script&lang=js"
export * from "./TravellerMsg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports